import React from "react"
import { Tooltip } from "antd"
import { useTranslation } from "react-i18next"
import { Globe as GlobeIcon } from "react-feather"
import SettingsLayout from "../settings.layout"
import GetMyInvoicesSettings from "./getMyInvoicesIntegration"

const UserIntegrations = () => {
    const { t } = useTranslation()
    return (
        <SettingsLayout
            preTitle={
                <Tooltip title={t("tooltips:setting_scope.global")}>
                    <GlobeIcon className="mr-10" />
                </Tooltip>
            }
            titleKey="label:integrations"
        >
            <div className="flex flex-col w-full justify-items-center">
                <GetMyInvoicesSettings />
            </div>
        </SettingsLayout>
    )
}

export default UserIntegrations
